<template>
  <div class="form-group tex-center d-flex align-items-center flex-column">
    <input style="display: none;" ref="file" type="file" class="form-control" @change="onChange($event)">
    <big-image-component
        :url="this.imageURL == null ? 'https://selectum-cruise-images.s3.eu-central-1.amazonaws.com/web-images/image-uploader-default-image.jpeg'
                                    :  this.imageURL ">
    </big-image-component>
    <button style="margin-top: 10px" class="btn btn-info btn-sm" type="button" @click="$refs.file.click()">Choose an image</button>
  </div>
</template>

<script>

import BigImageComponent from "./BigImageComponent";

export default {
  name: "UploadImage",
  components: {BigImageComponent},
  props: {
    imageURL: {
      type: String,
    }
  },
  model: {
    prop: 'imageURL',
    event: "change"
  },
  methods:{
    onChange: function (e) {
      const file = e.target.files[0];
      const reader = new FileReader();

      reader.readAsDataURL(file);

      e.target.value = '';

      reader.onloadend = (() => {
        this.$emit("change", reader.result)
      });
      return false;
    },
  }
}
</script>

<style scoped>

</style>